export default __webpack_public_path__ + "static/media/chevron-left.inline.d2c13873.svg";